import { FilteredCongestionReportsParagraphProps } from 'components/CongestionReportsParagraph';
import { exactDateFormatter, quarterDateFormatter } from 'src/utils/dateFormatter';
import { commaSeparatedStringFormatter } from 'src/utils/commaSeparatedStringFormatter';
import { bandWidthDateFormatter } from 'src/utils/bandwidth/bandWidthDateFormatter';
import { capitalizeLocationName } from 'src/utils';

import { FALLBACK_VALUE } from '../constant/constants';
import { stringToRichTextList } from './stringToRichText';
import { reportDates } from './reportDates';

type CongestionReport = FilteredCongestionReportsParagraphProps['congestionReport'];

export const getReplaceText = (congestionReport: CongestionReport): Record<string, string> => {
  return {
    '{affectedPostalCodes}':
      commaSeparatedStringFormatter(congestionReport?.affectedPostalCodes) ?? FALLBACK_VALUE,
    '{announcementExactDate}': exactDateFormatter(
      congestionReport?.announcementDate,
      FALLBACK_VALUE
    ),
    '{announcementQuarterDate}': quarterDateFormatter(
      congestionReport?.announcementDate,
      FALLBACK_VALUE
    ),
    '{availableTransportCapacity}': congestionReport?.availableTransportCapacity?.toString() ?? '0',
    '{completionExactDate}': exactDateFormatter(congestionReport?.completionDate, FALLBACK_VALUE),
    '{completionQuarterDate}': quarterDateFormatter(
      congestionReport?.completionDate,
      FALLBACK_VALUE
    ),
    '{congestionManagementExactPublicationDate}': exactDateFormatter(
      congestionReport?.congestionManagementPublicationDate,
      FALLBACK_VALUE
    ),
    '{congestionManagementQuarterPublicationDate}': quarterDateFormatter(
      congestionReport?.congestionManagementPublicationDate,
      FALLBACK_VALUE
    ),
    '{congestionType}': congestionReport?.congestionType
      ? congestionReport?.congestionType.toLowerCase()
      : FALLBACK_VALUE,
    '{locations}': commaSeparatedStringFormatter(congestionReport?.locations) ?? FALLBACK_VALUE,
    '{name}': congestionReport?.name
      ? capitalizeLocationName(congestionReport?.name)
      : FALLBACK_VALUE,
    '{requiredTransportCapacityInSolutionYear}':
      congestionReport?.requiredTransportCapacityInSolutionYear?.toString() ?? '0',
    '{resolvedExactDate}':
      bandWidthDateFormatter({
        bandWidthStartDate: congestionReport?.resolvedStartDate,
        bandWidthEndDate: congestionReport?.resolvedDate,
        callbackFunction: (date) => exactDateFormatter(date, FALLBACK_VALUE),
      }) ?? FALLBACK_VALUE,
    '{resolvedQuarterDate}':
      bandWidthDateFormatter({
        bandWidthStartDate: congestionReport?.resolvedStartDate,
        bandWidthEndDate: congestionReport?.resolvedDate,
        callbackFunction: (date) => quarterDateFormatter(date, FALLBACK_VALUE),
      }) ?? FALLBACK_VALUE,
    '{solution}': stringToRichTextList(congestionReport?.solution) ?? FALLBACK_VALUE,
    '{status}': congestionReport?.status ?? FALLBACK_VALUE,
    '{updatedAtExactDate}': exactDateFormatter(congestionReport?.updatedAtDate, FALLBACK_VALUE),
    '{updatedAtQuarterDate}': quarterDateFormatter(congestionReport?.updatedAtDate, FALLBACK_VALUE),
    '{publicationAndUpdatedExactDate}': reportDates({
      publicationDate: congestionReport?.congestionManagementPublicationDate,
      updatedAtDate: congestionReport?.congestionManagementUpdatedAtDate,
      fallbackValue: FALLBACK_VALUE,
    }),
    '{causeMainAsset}': congestionReport?.causeMainAsset ?? FALLBACK_VALUE,
    '{resolvedDateMainAsset}':
      bandWidthDateFormatter({
        bandWidthStartDate: congestionReport?.resolvedStartDateMainAsset,
        bandWidthEndDate: congestionReport?.resolvedDateMainAsset,
        callbackFunction: (date) => exactDateFormatter(date, FALLBACK_VALUE),
      }) ?? FALLBACK_VALUE,
  };
};
